import angular from 'angular';

SubscriptionsOptOutModalController.$inject = ['$scope', '$uibModalInstance', 'memberName'];

function SubscriptionsOptOutModalController($scope, $uibModalInstance, memberName) {
  const ctrl = {
    memberName: memberName,

    init: function () {},

    close: function () {
      $uibModalInstance.dismiss('cancel');
    },

    done: function () {
      $uibModalInstance.close('success');
    },
  };

  $scope.optOutModal = ctrl;
  ctrl.init();
}

export const SubscriptionsOptOutModalControllerModule = angular
  .module('acme.view.application.subscriptions.controllers.opt-out-modal', [])
  .controller('OptOutModalControler', SubscriptionsOptOutModalController).name;
